export namespace config {
  export let supportMoreMaskDivisions = true;
}
